// Entry point: default some fields, wire up the "Add" buttons and the per-
// section Run buttons, then load the issuer directory automatically.

import { run, SECTIONS, sectionEl, set, getDirectory } from "./api";

/**
 * "Add" appends another custom (type, info) row to Build extensions, each with
 * its own Remove button.
 */
function addCustomExtRow(): void {
  const rows = document.getElementById("custom-ext-rows");
  if (!rows) return;
  const row = document.createElement("div");
  row.className = "ext-row";
  row.innerHTML =
    '<label>type <input data-p="type" type="number" min="1" max="65535" placeholder="(optional)" /></label> ' +
    '<label>info (hex) <input data-p="info" placeholder="(optional)" /></label> ' +
    '<button type="button" class="secondary remove-ext">Remove</button>';
  row.querySelector(".remove-ext")?.addEventListener("click", () => row.remove());
  rows.appendChild(row);
}

/**
 * "Add extension" appends an extension-set entry (type + required checkbox) to
 * Create challenge, each with its own Remove button. Order matters: the type
 * field precedes its checkbox so the server can pair repeated es-type/es-
 * required params by position.
 */
function addExtSetRow(): void {
  const rows = document.getElementById("es-rows");
  if (!rows) return;
  const row = document.createElement("div");
  row.className = "ext-row";
  row.innerHTML =
    '<label>type <input data-p="es-type" type="number" min="1" max="65535" placeholder="(optional)" /></label> ' +
    '<label>required <input data-p="es-required" type="checkbox" /></label> ' +
    '<button type="button" class="secondary remove-ext">Remove</button>';
  row.querySelector(".remove-ext")?.addEventListener("click", () => row.remove());
  rows.appendChild(row);
}

window.addEventListener("load", () => {
  // Default the directory URL to this origin and the issuer name to this domain.
  set("directory", "url", location.origin + "/.well-known/private-token-issuer-directory");
  set("challenge-create", "issuer-name", location.hostname);
  document.getElementById("add-ext")?.addEventListener("click", addCustomExtRow);
  document.getElementById("add-es")?.addEventListener("click", addExtSetRow);
  for (const id of Object.keys(SECTIONS)) {
    const btn = sectionEl(id)?.querySelector<HTMLButtonElement>("[data-run]");
    if (btn) btn.addEventListener("click", () => run(id));
  }
  // The issuer directory has no button -- load it automatically.
  getDirectory();
});
